import RetryStrategyValues from 'eflex/constants/retry-strategy-values';

export default [
  { value: RetryStrategyValues.always, label: 'plant.task.retryStrategies.always' },
  { value: RetryStrategyValues.rejects, label: 'plant.task.retryStrategies.rejects' },
  { value: RetryStrategyValues.never, label: 'plant.task.retryStrategies.never' },
];
